import React from "react"
import { Box, Tile } from "@carrotfertility/carotene-core"
import { BookingBreadcrumbs } from "../../Breadcrumbs"

export function InsuranceLayout({ children }: React.PropsWithChildren): JSX.Element {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(theme.tokens.spacing.lg),
        inlineSize: "100%",
        maxInlineSize: 640
      })}
    >
      <BookingBreadcrumbs />
      <Tile
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          boxShadow:
            "0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.20)",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: theme.spacing(theme.tokens.spacing.lg),
          inlineSize: "100%",
          maxInlineSize: 640,
          boxSizing: "border-box"
        })}
      >
        {children}
      </Tile>
    </Box>
  )
}
